<div class="modal-header">
  <h4 class="modal-title">Export Asset List</h4>
  @if (!loaderVisible) {
    <div>
      <mtm-asset-list-actions
        [assets]="originalAssets"
        [campaignId]="campaignId"
        [enableOrientationSelection]="true"
        [enableViewModeSwitching]="false"
        [enableExportAction]="false"
        [enableTextSearch]="false"
        [currentSort]="currentSort"
        [currentOrientation]="orientation"
        [selectedProjectIds]="selectedProjectIds"
        [selectedFocusValues]="selectedFocusValues"
        [selectedTypeValues]="selectedTypeValues"
        [selectedBetsValues]="selectedBetsValues"
        [selectedDurationValues]="selectedDurationValues"
        [selectedFormatValues]="selectedFormatValues"
        [selectedCategoriesValues]="selectedCategoriesValues"
        [selectedInUseValues]="selectedInUseValues"
        [selectedStatusValues]="selectedStatusValues"
        [selectedReleaseDateValues]="selectedReleaseDateValues"
        [showHiddenOnly]="showHiddenOnly"
        (currentSortChange)="onSortChange($event)"
        (currentExportOrientationChange)="onOrientationChange($event)"
        (selectedProjectIdsChange)="onSelectedProjectIdsChange($event)"
        (selectedFocusValuesChange)="onSelectedFocusValuesChange($event)"
        (selectedTypeValuesChange)="onSelectedTypeValuesChange($event)"
        (selectedBetsValuesChange)="onSelectedBetsValuesChange($event)"
        (selectedDurationValuesChange)="onSelectedDurationValuesChange($event)"
        (selectedFormatValuesChange)="onSelectedFormatValuesChange($event)"
        (selectedCategoriesValuesChange)="onSelectedCategoriesValuesChange($event)"
        (selectedInUseValuesChange)="onSelectedInUseValuesChange($event)"
        (selectedStatusValuesChange)="onSelectedStatusValuesChange($event)"
        (selectedReleaseDateValuesChange)="onSelectedReleaseDateValuesChange($event)"
        (showHiddenOnlyChange)="onShowHiddenOnlyChange($event)" />
    </div>
  }
</div>

<div class="modal-body" [class.loading]="loaderVisible">
  @if (loaderVisible) {
    <div class="col loader-div">
      <div class="d-flex justify-content-center align-items-center h-100">
        <div class="spinner-grow bg-danger" style="width: 3rem; height: 3rem" role="status">
          <span class="visually-hidden"></span>
        </div>
        <div style="position: absolute; padding-top: 100px">
          <h5 class="text-dark text-uppercase font-weight-bold">{{ 'processing' | translate }}</h5>
        </div>
      </div>
    </div>
  }
  <div class="preview-section">
    <ng-container *ngFor="let p of assetsPerPages; let pIndex = index">
      <div class="wrapper">
        <div #pdfPage class="pdf-page pdf-page--{{ orientation }}">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th scope="col" class="table-view__header">{{ 'asset' | translate }}</th>
                <th scope="col" class="table-view__header">
                  {{ 'categories' | translate }}
                </th>
                <th scope="col" class="table-view__header">
                  {{ 'Platform' | translate }}
                </th>
                <th scope="col" class="table-view__header">{{ 'funnel' | translate }}</th>
                <th *ngIf="showFocus" scope="col" class="table-view__header">
                  {{ 'focus' | translate }}
                </th>
                <th scope="col" class="table-view__header">{{ 'releaseDate' | translate }}</th>
                <th *ngIf="showRegions" scope="col" class="table-view__header">{{ 'region' | translate }}</th>
                <th *ngIf="showAgency" scope="col" class="table-view__header">{{ 'agency' | translate }}</th>
                <th *ngIf="showLength" scope="col" class="table-view__header">{{ 'length' | translate }}</th>
                <th *ngIf="showTypes" scope="col" class="table-view__header">{{ 'type' | translate }}</th>
                <th *ngIf="showFormat" scope="col" class="table-view__header">{{ 'format' | translate }}</th>
              </tr>
            </thead>

            <tbody>
              <ng-container class="table-row" *ngFor="let item of p">
                <tr>
                  <th scope="col" class="table-view__cell text-center {{ item?.parentId ? 'bg-white' : '' }}">
                    <div class="d-flex items-center justify-content-between">
                      <div class="d-flex items-center">
                        <img alt="expanded" *ngIf="item?.subAsset?.length > 0" src="assets/svg/expanded.svg" />
                        <img
                          alt="hierarchical-indent"
                          *ngIf="item?.parentId"
                          src="assets/svg/hierarchical-indent.svg" />
                        <div *ngIf="!item?.subAsset?.length && !item.parentId" class="w-48px"></div>
                        <span>{{ item.title || item.detail }}</span>
                      </div>
                      <div class="d-flex items-center justify-content-end gap-2">
                        <img alt="master" *ngIf="!item?.parentId" src="assets/svg/master.svg" />
                        <span class="f-9" *ngIf="!item?.parentId">Master</span>
                        <img alt="tech-variant" *ngIf="item?.parentId" src="assets/svg/tech-variant.svg" />
                        <span class="f-9" *ngIf="item?.parentId">TECH. VARIANT</span>
                      </div>
                    </div>
                  </th>
                  <td class="table-view__cell {{ item?.parentId ? 'bg-white' : '' }}">
                    {{ item.categories?.join(', ') || '-' }}
                  </td>
                  <td class="table-view__cell {{ item?.parentId ? 'bg-white' : '' }}">
                    <div class="d-flex flex-column gap-2">
                      <div *ngFor="let b of item.bets" class="d-flex items-center gap-1">
                        <i class="mtm-icon mtm-icon-{{ b?.toLowerCase() }}"></i>
                        <span class="f-8">{{ b }}</span>
                      </div>
                    </div>
                  </td>
                  <td class="table-view__cell {{ item?.parentId ? 'bg-white' : '' }}">
                    {{ item.funnel }}
                  </td>
                  <td *ngIf="showFocus" class="table-view__cell {{ item?.parentId ? 'bg-white' : '' }}">
                    {{ item.focus }}
                  </td>
                  <td class="table-view__cell {{ item?.parentId ? 'bg-white' : '' }}">
                    {{ item?.releaseDate ? (item.releaseDate | ngbDate) : '-' }}
                  </td>
                  <td *ngIf="showRegions" class="table-view__cell {{ item?.parentId ? 'bg-white' : '' }}">
                    {{ item.region || '' }}
                  </td>
                  <td *ngIf="showAgency" class="table-view__cell {{ item?.parentId ? 'bg-white' : '' }}">
                    {{ item.agency || '' }}
                  </td>
                  <td *ngIf="showLength" class="table-view__cell {{ item?.parentId ? 'bg-white' : '' }}">
                    {{ item.product || '' }}
                  </td>
                  <td class="table-view__cell {{ item?.parentId ? 'bg-white' : '' }}">
                    <div class="d-flex flex-column gap-2">
                      <div *ngFor="let l of item.length">
                        {{ l }}
                      </div>
                    </div>
                  </td>
                  <td *ngIf="showTypes" class="table-view__cell {{ item?.parentId ? 'bg-white' : '' }}">
                    {{ item.type }}
                  </td>
                  <td class="table-view__cell {{ item?.parentId ? 'bg-white' : '' }}">
                    {{ item.format }}
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
        <div class="d-flex mb-3 justify-content-center f-11">
          <span class="_700">{{ pIndex + 1 }}</span
          >/{{ totalPages }}
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn cancel-btn" (click)="onCancel()">CANCEL</button>
  @if (!loaderVisible) {
    <div class="export-btn-container">
      <button type="button" [disabled]="isLoading" class="btn export-btn" (click)="onExportClick($event)">
        EXPORT
        <img alt="down-arrow" src="../../../../assets/img/down-arrow.svg" />
      </button>
      <div class="export-type-modal" *ngIf="showExportTypeModal" (onKeyPress)="$event.stopPropagation()">
        <h3>Type</h3>
        <div class="export-types">
          <div *ngFor="let type of exportTypes" class="export-type-option">
            <input
              type="checkbox"
              [id]="type"
              [checked]="selectedExportTypes.includes(type)"
              (change)="onExportTypeSelect(type)"
              class="form-check" />
            <label [for]="type">{{ type }}</label>
          </div>
        </div>
        <button [disabled]="!selectedExportTypes.length" type="button" class="download-btn" (click)="onExport()">
          DOWNLOAD
        </button>
      </div>
    </div>
  }
</div>
